import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import API from "../../../api/baseApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const Newsletter = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const client = useSelector((state) => state.clients.selectedClient?.value);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await API.get("/customers/newsletters");
      if (res.data?.success) {
        setData(res.data.data || []);
      } else {
        toast.error("Failed to fetch newsletter records");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching newsletter records");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [client]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "email",
        header: "Email",
        size: 250,
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 150,
      },
      {
        accessorKey: "createdAt",
        header: "Date",
        size: 150,
        Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString(),
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    state: { isLoading },
    enableRowActions: false,
    enableColumnOrdering: true,
    enableGlobalFilter: true,
  });

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Newsletter Subscriptions" parent="Pages" title="Newsletter Subscriptions" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <MaterialReactTable table={table} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Newsletter;
